export class Nationality {
    id : number;
    nationalityCode : string;
    nationalityName : string;
}